/* Trendbox Willkommensbox - erzeugt aus dem Prototyp, NICHT von Hand aendern.
   Quelle: dashboard/public/lp-prototypes/tb-willkommensbox.html
   Neu bauen: python dashboard/scripts/build_willkommensbox_theme.py */
(function () {
  "use strict";

  // Bilder liegen als Theme-Assets. Die Section schreibt die fertigen URLs nach
  // window.WB_ASSETS - in einer .js-Datei laeuft kein Liquid, asset_url gibt es
  // hier also nicht.
  function wbAsset(name) {
    var m = window.WB_ASSETS || {};
    return m[name] || "";
  }

  var istLP = !!document.querySelector('[data-seite="lp"]');
  var istFlow = !!document.querySelector('[data-seite="flow"]');
  if (!istLP && !istFlow) return;

  // Adressen der beiden Seiten, von der Section gesetzt.
  var WB_URL = window.WB_URL || {};


  /* ---- Daten (aus tb-willkommensbox-data.js) ---- */
  // Daten fuer den Willkommensbox-LP-Prototyp.
  // Sets: generiert aus analysis/out/willkommensbox-kandidaten.json (Task 2),
  //       Namen von Hand kuratiert. Bestueckung ist ein VORSCHLAG - Freigabe
  //       liegt bei Robin/Lene (Spec §14, Punkt 4).
  //       Kuration ersetzt 5 der 6 generierten Sets: der Algorithmus bevorzugt
  //       "ein teures Produkt + Restfuellung" (z.B. 62 EUR Gel-Creme + 3,95 EUR
  //       Gruesskarte + 4,69 EUR Lippenbalsam), weil im 100+-Lagerbestand-Pool
  //       nur ~14 Artikel ueber 14 EUR liegen. Die sechs Sets hier bestehen wo
  //       moeglich aus 3-4 Artikeln im mittleren Preisband statt Anker+Fuellsel
  //       (Vorbild: das generierte set-6, Sommer-Socken+Anti-Aging+Peeling).
  //       Die SipGuard-Artikel ("Drink Teststreifen", "Drink Teststicker" -
  //       K.-o.-Tropfen-Tests) sind bewusst in keinem Set: Stimmungsbruch in
  //       einem Willkommensgeschenk. Ebenfalls bewusst nicht verwendet: Yoni
  //       Bio-Tampons, Lansinoh Kuehlender Koerperbalsam (Still-/Schwangerschafts-
  //       Marke, Zielgruppenpassung im generischen Willkommensgeschenk unklar)
  //       sowie Baby-Artikel (Babyloeffel, Babyalbum Sticker Set, Stoffwindel) -
  //       zu persoenlich/zielgruppenspezifisch fuer ein generisches Willkommens-
  //       geschenk. Details und Verwerfungsgruende: task-3-report.md.
  //       Nachtrag 11.08.2026: Set-Korridor auf 25-80 EUR / 3-10 Artikel
  //       geweitet (alte 50-80-EUR-Regel machte ein Food&Drinks-Set unmoeglich -
  //       alle 19 lagernden Food&Drinks-Artikel zusammen ergeben nur 42,98 EUR).
  //       Dafuer "Gesichtspflege-Extras" ersetzt durch "Genuss-Set" (10 Food&
  //       Drinks-Artikel, 31,36 EUR - die zehn wertvollsten lagernden Artikel
  //       der Kategorie, siehe task-3-report.md).
  // Reviews: echte Trusted-Shops-Zitate aus analysis/out/voc/trusted_shops.jsonl.
  // Track-Record: PLATZHALTER. Die reporting-Postgres ist Coolify-intern und
  //       von lokal nicht erreichbar (DATABASE_URL fehlt in reporting/.env).
  //       Die boxplan-Postgres (localhost:5432/boxplan) - dort liegt mit
  //       PurchaseItem.priceUvp die einzige echte Quelle fuer "welche Produkte
  //       steckten in welcher Box und was waren sie wert" - laeuft auf dieser
  //       Maschine nicht. Die archivierten Boxen in Shopify (Springtime,
  //       Franka, Silvana ASMR ...) sind Themen-/Influencer-Boxen, keine
  //       vergangenen Willkommensboxen - als Track Record irrefuehrend, daher
  //       NICHT verwendet. Echte Werte muessen vor Live-Gang aus boxplan
  //       PurchaseItem kommen, gruppiert je Box-Monat, Summe priceUvp. Die
  //       Bild-Slots nutzen echte, bereits vorhandene Trendbox-Community-Fotos
  //       (dashboard/public/lp-prototypes/img/tb-community-*.jpg) als Platzhalter-
  //       Bebilderung - keine erfundenen Bilder, aber auch nicht die Fotos der
  //       tatsaechlichen Monatsbox, die noch nicht vorliegen.
  
  window.WB_DATA = {
    preis: { monat: 33.95, waehrung: "€" },
  
    willkommensbox: {
      // 25.08.2026: 113,55 € raus, Untergrenze rein. Stephan (Einkauf) in
      // #lp-offensive: die Augustbox = Willkommensbox traegt real 105,95 € bei 10+
      // Produkten, und auf die Frage, welche Zahl auf die Seite kommt, hat er
      // Option (c) gewaehlt - "eine Untergrenze, die jeden Monat haelt, z. B.
      // mind. 100 € Warenwert". Damit muss die Zahl beim Monatswechsel nicht
      // nachgezogen werden; ein Deploy je Monatswechsel waere laut Stephan zwar
      // ok gewesen ("passt auch fuer uns"), ist so aber gar nicht mehr noetig.
      // Ein Editor-Feld im Theme braucht es aus demselben Grund vorerst nicht.
      //
      // 25.08. 16:05 ENTSCHIEDEN vom Einkauf, damit ist die Flanke zu. Stephan in
      // #lp-offensive: "Ich wuerde dauerhaft mit 10+ Produkte im Wert von mindestens
      // 100 € arbeiten. Damit bleibt die Aussage belastbar und wir muessen beim
      // Monatswechsel nicht zwingend aktualisieren. Die aktuell genannten 80 bis
      // 100 € muessten dann entsprechend raus, da die Augustbox bereits bei
      // 105,95 € liegt." Zwischen 14:11 und 16:05 stand hier 105 - Alex' Wahl, vom
      // Einkauf nicht getragen. Der Einkauf traegt 100, also stehen hier 100.
      //
      // Was das kostet: der Anker faellt von 171,45 € auf 166,45 €. Spec §12 - die
      // A-Variante (/pages/gratis-bestseller-box) wirbt live mit "Über 165,00 €
      // Warenwert" bei 29,95 € Einstieg, wir liegen mit 166,45 € bei 33,95 € nur
      // 1,45 € darueber. Das war Alex' Grund fuer die 105 und ist mit der
      // Entscheidung nicht verschwunden, sondern nur nicht mehr unsere Wahl: eine
      // Zahl, die der Einkauf nicht zusagt, gehoert nicht auf die Seite. Scheitert
      // der Test daran, ist es ein Angebots-Problem, kein Zahlen-Problem.
      //
      // Was die alten 113,55 € waren: rueckwaerts gerechnet, keine Einkaufszahl.
      // Der Anker ueber dem Bestell-Button sollte glatt 180,00 € sein, das teuerste
      // Set traegt 66,45 € => 180,00 - 66,45 = 113,55.
      //
      // 10.09.2026 ENTSCHIEDEN: 100 -> 80. Michelle (09.09., Punkt 5) wollte in der
      // FAQ "mind. 80 €"; auf Rueckfrage, ob es bei den 100 aus seiner Zusage vom
      // 25.08. bleibt, hat Stephan im Thread geantwortet: "Dann nehmen wir die mind.
      // 80€ von Michelle und bleiben ueber die kommenden Monate stringent in der
      // Aussage zur Box." Der Wert steht an EINER Stelle, also zieht die Antwort
      // die ganze Seite mit - nicht nur die FAQ-Zeile:
      //   Ablauf-Schritt 2, Ablauf-Schritt 3, Angebotskarte, Zahlen-Band, FAQ 1
      //     "Warenwert mind. 100 €" -> "mind. 80 €"
      //   Anker (max(Set) + Boxwert), 5 Fundstellen: Annbar, Hero-Fakt,
      //     Ablauf-Schritt 1, Angebotskarte-Summe, Wert-Diagramm
      //     64,95 + 100 = 164,95 -> "164 €"  wird zu  64,95 + 80 = 144,95 -> "144 €"
      // Das ist der Preis der Stringenz: die A-Variante (/pages/gratis-bestseller-box)
      // wirbt live mit "Über 165,00 € Warenwert" bei 29,95 € Einstieg, wir stehen
      // dann mit 144 € bei 33,95 €. Real traegt die Augustbox 105,95 € - die 80 sind
      // die Untergrenze, die der Einkauf jeden Monat halten will, nicht der Inhalt.
      //
      // Die Zusage traegt weiterhin der Einkauf, nicht die Seite.
      wert: 80,
      // true => die Seite schreibt "mind. 105 €" statt "105,00 €" (Untergrenze,
      // keine Momentaufnahme). Bei false rendert der Betrag wie jeder andere.
      wertIstUntergrenze: true,
      // 21.08.2026: von "8+" auf "10+" gezogen. Freigabe von Lene in #lp-offensive
      // (20.08. "Ja gilt auch fuer die Willkommensbox ... Bestseller Box hat ja auch
      // immer 10 Produkte", 21.08. "Ich sag jetzt einfach mal Ja zu mind. 10 Produkte").
      // Vorher stand hier bewusst "8+", weil Lenes Aussage vom 13.08. der MONATSBOX
      // galt und "10+" eine Zusage an den Einkauf gewesen waere, die niemand gegeben
      // hatte. Diese Zusage liegt jetzt vor - sie ist damit aber auch verbindlich:
      // ACHTUNG, wie bei wert: 113,55 € traegt der Einkauf sie, nicht die Seite. Die
      // Bestueckung der Willkommensbox ist weiterhin nicht freigegeben.
      produkte: "10+",
      kategorien: ["Food & Drinks", "Wellness & Beauty", "Lifestyle & Design"],
    },
  
    // 09.09.2026: die sechs FINALEN Sets (Robin/Michelle, Sheet
    // 1xM62TCqlzVRVUy4-AK5bT1Q50pxZ7BYsxM1jPW5XY7I Tab 847226569, 04.09. "Das waeren
    // dann jetzt die finalen Geschenksets"; Lene: "Fit Food" statt "Energy & Fit",
    // "Feels Like Summer Bundle" statt "Late Summer Set"). Drei Sets liegen unter
    // 25 EUR - das ist die Entscheidung des Teams, nicht der Seite.
    // `bild` = Robins Header-Bild je Set (Drive-Ordner 1kRCYTAi5mgqfVukrQhX93fHFFmf9TaVK,
    // 1200x675, Daily Essentials 1000x675). imageUrl je Artikel nur noch Beiwerk.
    // value = Summe der Einzelpreise laut Sheet, nicht gerundet.
    //
    // 09.09.2026 (Stephan, #projekt-lp-offensive 21:01): Preis-Aesthetik. Die
    // Set-Werte sind nicht mehr die rohe Sheet-Summe, sondern die von ihm
    // vorgegebenen kommunizierten Warenwerte:
    //   Suesse Auszeit   13,06 -> 12,95   Fit Food        17,41 -> 16,95
    //   Eco Home         17,79 -> 16,95   Genuss-Set      28,73 -> 27,95
    //   Feels Like Summer 49,90 (unveraendert)  Daily Essentials 66,45 -> 64,95
    //
    // Die Seite zeigt je Set AUCH die Einzelpreise (Zeile ~907 in der HTML), und
    // check_willkommensbox_prototype.mjs prueft value == Summe der Einzelpreise.
    // Ein gerundeter Set-Wert bei unveraenderten Einzelpreisen waere also eine
    // Liste, die sichtbar nicht aufgeht. Stephan hat genau das mitentschieden:
    // "Dem entsprechend die Produkte in den Sets vom Einzel-VK auf der LP nur
    // anpassen." Die Differenz traegt deshalb je Set EIN Artikel, bevorzugt einer
    // ohne imageUrl (= wir hatten dort ohnehin keinen Shop-Preis, sondern eine
    // Sheet-Angabe), damit moeglichst wenige Preise von der Realitaet abweichen:
    //   Popcorn Franzbroetchen  2,95 -> 2,84   (Suesse Auszeit,   -0,11)
    //   Knaeckebrot mit Algen   3,99 -> 3,53   (Fit Food,         -0,46)
    //   Wiederverschliess-Clips 6,95 -> 6,11   (Eco Home,         -0,84)
    //   Zitronenpasta           3,60 -> 2,82   (Genuss-Set,       -0,78)
    //   Parfuem Fernway        32,00 -> 30,50  (Daily Essentials, -1,50)
    //
    // Folge weiter oben auf der Seite: der Anker ist max(Set) + Boxwert. Am 09.09.
    // war das 64,95 + 100 = 164,95 -> "164 € Warenwert" (vorher 166). Seit Stephans
    // Antwort vom 10.09. steht der Boxwert bei 80, der Anker also bei 64,95 + 80 =
    // 144,95 -> "144 €" (siehe willkommensbox.wert). Nicht aufrunden (siehe
    // eurGanz): eine aufgerundete Zahl waere mehr, als die Seite zusagen kann.
    sets: [
      {
        key: "suesse-auszeit",
        name: "Süße Auszeit",
        value: 12.95,
        verfuegbar: true,
        bild: wbAsset("wb-set-suesse-auszeit.jpg"),
        items: [
          { title: "Popcorn Franzbrötchen", vendor: "Knalle", priceEur: 2.84, imageUrl: "https://cdn.shopify.com/s/files/1/0886/7007/7265/files/Knalle-Popcorn-Franzbroetchen.jpg?v=1745935176" },
          { title: "Vegane Kekse mit Kakaofüllung", vendor: "Pural", priceEur: 2.95, imageUrl: "https://cdn.shopify.com/s/files/1/0886/7007/7265/files/PURAL-Bio-bis-Choco-Vegan-1.jpg?v=1765556572" },
          { title: "Matcha-Sonnen Fruchtgummi", vendor: "Beauty Sweeties", priceEur: 2.19, imageUrl: "https://cdn.shopify.com/s/files/1/0886/7007/7265/files/Beauty-Sweeties-Fruchtgummis-Matcha-Green-Tea-1.jpg?v=1776948141" },
          { title: "Knuspriger Schokoriegel", vendor: "Naturata", priceEur: 1.99, imageUrl: "https://cdn.shopify.com/s/files/1/0886/7007/7265/files/Naturata-Milk-Crunch-1.jpg?v=1761817716" },
          { title: "Bio Fruchtgummis", vendor: "nature gummies", priceEur: 1.59, imageUrl: "https://cdn.shopify.com/s/files/1/0886/7007/7265/files/nature-gummies-bio-fruchtgummi-favorite-fruit-1_d2fcc82d-98d4-46e0-bd79-9da506486d99.jpg?v=1756206935" },
          { title: "Crunchy Snack Ananas", vendor: "Puffins", priceEur: 1.39, imageUrl: "https://cdn.shopify.com/s/files/1/0886/7007/7265/files/puffins-Ananas-1.jpg?v=1753802566" },
        ],
      },
      {
        key: "daily-essentials",
        name: "Daily Essentials Set",
        value: 64.95,
        verfuegbar: true,
        bild: wbAsset("wb-set-daily-essentials.jpg"),
        items: [
          { title: "Parfüm Fernway", vendor: "Sentier", priceEur: 30.5, imageUrl: "https://cdn.shopify.com/s/files/1/0886/7007/7265/files/Sentier-Parfuem-Fernway-1.jpg?v=1777557507" },
          { title: "Vitamin Infused Gesichtsserum", vendor: "Mudmasky", priceEur: 27.5, imageUrl: "https://cdn.shopify.com/s/files/1/0886/7007/7265/files/Mudmasky-Vitamin-Infused-Scalp-Serum.jpg?v=1774974762" },
          { title: "Intensiv pflegende Handcreme", vendor: "newkee", priceEur: 6.95, imageUrl: "https://cdn.shopify.com/s/files/1/0886/7007/7265/files/newkee-handcreme-1_08b46acb-3881-49a2-afdb-3cfe56aae579.jpg?v=1769895556" },
        ],
      },
      {
        key: "fit-food",
        name: "Fit Food",
        value: 16.95,
        verfuegbar: true,
        bild: wbAsset("wb-set-fit-food.jpg"),
        items: [
          { title: "Knäckebrot mit Algen", vendor: "Algenladen", priceEur: 3.53 },
          { title: "Kichererbsenwaffeln", vendor: "byodo", priceEur: 2.49, imageUrl: "https://cdn.shopify.com/s/files/1/0886/7007/7265/files/byodo-kichererbsenwaffeln-4.jpg?v=1747062979" },
          { title: "Natürlich Funktionaler Energydrink", vendor: "DOC Weingart", priceEur: 2.07, imageUrl: "https://cdn.shopify.com/s/files/1/0886/7007/7265/files/DOC-Weingart-REFOCUS-Orange-Zitrone-Grapefruit.jpg?v=1745477808" },
          { title: "Crunchy Snack", vendor: "Puffins", priceEur: 1.39, imageUrl: "https://cdn.shopify.com/s/files/1/0886/7007/7265/files/puffins-Ananas-1.jpg?v=1753802566" },
          { title: "Bio Protein Snack", vendor: "byodo", priceEur: 2.49, imageUrl: "https://cdn.shopify.com/s/files/1/0886/7007/7265/files/byodo-protein-knusperecken-rote-linse-1_5ee561a9-8163-4fc0-a961-154d619ed00b.jpg?v=1769895479" },
          { title: "High Protein Kakao Shake", vendor: "PUR YA", priceEur: 1.99 },
          { title: "Kokoswasser", vendor: "vita coco", priceEur: 2.99, imageUrl: "https://cdn.shopify.com/s/files/1/0886/7007/7265/files/vita-coco-kokoswasser-kalorienarm-1.jpg?v=1779363170" },
        ],
      },
      {
        key: "feels-like-summer",
        name: "Feels Like Summer Bundle",
        value: 49.9,
        verfuegbar: true,
        bild: wbAsset("wb-set-feels-like-summer.jpg"),
        items: [
          { title: "Clear and Dry Sun Spray SF50", vendor: "Louis Widmer", priceEur: 27.0, imageUrl: "https://cdn.shopify.com/s/files/1/0886/7007/7265/files/Louis-Widmer-Sun-Clear-Dry-Spray-50-1.jpg?v=1777581726" },
          { title: "Daily Sunscreen 50+", vendor: "newkee", priceEur: 7.95, imageUrl: "https://cdn.shopify.com/s/files/1/0886/7007/7265/files/newkee-daily-sunscreen-1.jpg?v=1782851283" },
          { title: "Lip Balm SPF 30", vendor: "newkee", priceEur: 6.95, imageUrl: "https://cdn.shopify.com/s/files/1/0886/7007/7265/files/newkee-lip-balm-spf-30-1.jpg?v=1782851249" },
          { title: "Wiederverwendbares Abschminkpad", vendor: "waschies", priceEur: 8.0, imageUrl: "https://cdn.shopify.com/s/files/1/0886/7007/7265/files/waschies-wiederverwendbare-abschminkpads-1_0c9810d3-342a-4d34-922a-2977b0bf81c2.jpg?v=1780305267" },
        ],
      },
      {
        key: "eco-home",
        name: "Eco Home & Zero Waste",
        value: 16.95,
        verfuegbar: true,
        bild: wbAsset("wb-set-eco-home.jpg"),
        items: [
          { title: "Wiederverschließ-Clips", vendor: "Tütenhüter", priceEur: 6.11 },
          { title: "Bio-Saatgut", vendor: "Primoza", priceEur: 2.95, imageUrl: "https://cdn.shopify.com/s/files/1/0886/7007/7265/files/Primoza-Saatgut-Aubergine-Bambino.jpg?v=1742548298" },
          { title: "100 % Recycling-Tücher", vendor: "oecolife", priceEur: 1.69, imageUrl: "https://cdn.shopify.com/s/files/1/0886/7007/7265/files/oecolife-kosmetiktucher-1.jpg?v=1774974331" },
          { title: "Edelstahl Trinkhalm", vendor: "KNYG", priceEur: 3.75 },
          { title: "Allesreiniger", vendor: "HAKA", priceEur: 2.45, imageUrl: "https://cdn.shopify.com/s/files/1/0886/7007/7265/files/HAKA-Alles-Reiniger-Ultra-Konzentrat-1_ba762852-520b-405f-b59c-5b0a163eecbd.jpg?v=1777557650" },
        ],
      },
      {
        key: "genuss-set",
        name: "Genuss-Set",
        value: 27.95,
        verfuegbar: true,
        bild: wbAsset("wb-set-genuss-set.jpg"),
        items: [
          { title: "Erdbeer Fruchtaufstrich", vendor: "Karls", priceEur: 4.5, imageUrl: "https://cdn.shopify.com/s/files/1/0886/7007/7265/files/Karls-Erdbeer-Traum-Marmelade-1.jpg?v=1782850388" },
          { title: "Matcha Grüner Tee", vendor: "Monin", priceEur: 3.99, imageUrl: "https://cdn.shopify.com/s/files/1/0886/7007/7265/files/Monin-Matcha-Gruener-Tee-Konzentrat-1.jpg?v=1779362417" },
          { title: "Zitronenpasta", vendor: "Feinkost Manufaktur", priceEur: 2.82 },
          { title: "Kokoswasser", vendor: "vita coco", priceEur: 2.99, imageUrl: "https://cdn.shopify.com/s/files/1/0886/7007/7265/files/vita-coco-kokoswasser-kalorienarm-1.jpg?v=1779363170" },
          { title: "Wassereis", vendor: "SUN LOLLY", priceEur: 2.49, imageUrl: "https://cdn.shopify.com/s/files/1/0886/7007/7265/files/SUN-LOLLY-Wassereis-Johannisbeere-1.jpg?v=1774973905" },
          { title: "Bio Grünes Thai Curry", vendor: "Kooray", priceEur: 2.29, imageUrl: "https://cdn.shopify.com/s/files/1/0886/7007/7265/files/kooray-instant-sosse-bio-vegan-glutenfrei-gruenes-thai-curry-scharf-1.jpg?v=1783498048" },
          { title: "Funktionaler Energydrink", vendor: "DOC Weingart", priceEur: 2.07, imageUrl: "https://cdn.shopify.com/s/files/1/0886/7007/7265/files/DOC-Weingart-REFOCUS-Orange-Zitrone-Grapefruit.jpg?v=1745477808" },
          { title: "Tortilla Chips Meersalz", vendor: "Pural", priceEur: 1.8, imageUrl: "https://cdn.shopify.com/s/files/1/0886/7007/7265/files/Pural-Mais-Chips-Tortilla-Chips-Nature-1.jpg?v=1785519890" },
          { title: "Bio-Einkorn-Backferment", vendor: "Grana Antico", priceEur: 5.0, imageUrl: "https://cdn.shopify.com/s/files/1/0886/7007/7265/files/Grana-Antico-Einkorn-Backferment-Bio-Vegan-1.jpg?v=1779362183" },
        ],
      },
    ],
  
    // Echte SERVICE_REVIEWs, am 12.08.2026 ueber die etrusted-API gezogen
    // (channel chl-21457996-…, status APPROVED). Texte VERBATIM inkl. Eigenheiten
    // der Schreiberinnen - eine Bewertung, die man glattzieht, ist keine mehr.
    // Namen als Vorname + Initiale: die API liefert fullName, das ist PII. Die
    // Reviewerin hat der Veroeffentlichung bei Trusted Shops zugestimmt, nicht
    // ausdruecklich der auf unserer LP - die Abkuerzung ist die konservative
    // Variante. Vor Live-Gang trotzdem einmal gegen die TS-Bedingungen halten.
    //
    // Ausgewaehlt nach dem, was diese LP beweisen muss - nicht nach "klingt nett":
    // 1. die erste Box hat gehalten (Kerstin F. spricht ueber genau die Lieferung,
    //    die hier verkauft wird, und die Vorfreude auf die Monatsbox danach)
    // 2. die Ueberraschung enttaeuscht nicht (Ute Khadija S. - der Einwand, den
    //    eine Mystery-Box aufwirft, wortwoertlich entkraeftet)
    // 3. Entdecken statt Sparen (Rebecca W., aktuell, ohne Preisargument)
    // 17.09. (Michelle: "von neu nach alt sortieren? haben wir September-
    // Bewertungen?"): vorne stehen jetzt die drei neuesten passenden aus dem
    // September (etrusted-API, APPROVED, 5 Sterne, Text wortgleich, nur Zeilen-
    // umbrueche zu Leerzeichen). Die ganze Liste laeuft von neu nach alt; die
    // bisherigen drei rutschen hinter "Mehr Bewertungen lesen".
    reviews: [
      {
        name: "Julia Z.",
        namePlatzhalter: false,
        datum: "2026-09-11",
        sterne: 5,
        text: "Ich freue mich jeden Monat auf meine Trendbox :) Es ist immer eine Überraschung und in den meisten Fällen kann ich diese Überraschungen auch wirklich gut gebrauchen. Ist das mal nicht der Fall schenke ich die Sachen an Freunde weiter :)",
      },
      {
        name: "Andrea T.",
        namePlatzhalter: false,
        datum: "2026-09-09",
        sterne: 5,
        text: "Diesmal ist die Trendbox wirklich mega toll. Sehr vielseitig und ich bin sehr gespannt aufs probieren und ausprobieren. Vielen Dank ans Team",
      },
      {
        name: "Armgard B.",
        namePlatzhalter: false,
        datum: "2026-09-08",
        sterne: 5,
        text: "Ich freue mich jeden Monat auf meine Box, man merkt das die Sachen liebevoll ausgesucht sind. Vielen Dank dafür.",
      },
      // Ab hier: die neun, die erst auf "Mehr Bewertungen lesen" erscheinen
      // (Robin 13.08.: der Knopf tat vorher NICHTS - er hatte Markup und CSS, aber
      // nirgends einen Klick-Handler). Am 13.08.2026 frisch ueber dieselbe
      // etrusted-API gezogen wie die drei oben, Kanal chl-21457996-…, nur APPROVED,
      // nur 5 Sterne, nur die letzten 120 Tage. Namen wieder Vorname + Initiale.
      // Aus 58 brauchbaren ausgewaehlt nach dem, was diese Seite belegen muss:
      // Vorfreude aufs Auspacken · "noch nie enttaeuscht" ueber viele Monate ·
      // der Kategorien-Mix Food+Kosmetik, mit dem die Seite wirbt · Nutzwert
      // (gegen den "nettes Zeug, brauch ich nicht"-Einwand) · Lieferung + Neues
      // entdecken · konkrete Produkte, damit nicht alles im Allgemeinen bleibt.
      // Bewusst NICHT genommen: zwei Service-Faelle (zerbrochenes Bodyoel,
      // Bestellprobleme) - beide 5 Sterne, aber sie erzaehlen von einer Panne,
      // und die Loesung glaubt nur, wer die Panne schon hinter sich hat.
      {
        name: "Marlis P.",
        namePlatzhalter: false,
        datum: "2026-08-11",
        sterne: 5,
        text: "Vorfreude ist natürlich die schönste Freude...aber das Auspacken der Überraschungen erst recht! Alles ist irgendwie besonders.",
      },
      {
        name: "Andrea D.",
        namePlatzhalter: false,
        datum: "2026-08-09",
        sterne: 5,
        text: "Wir lernen jeden Monat so viele neue, tolle Produkte kennen! Waren noch nie enttäuscht. Haben immer eine Riesen- Freude, wenn wir die Box zusammen auspacken!",
      },
      {
        name: "Susanne H.",
        namePlatzhalter: false,
        datum: "2026-08-10",
        sterne: 5,
        text: "Mir gefallen die unterschiedlichen Produktrichtungen aus Lebensmitteln und Kosmetik. Die Masken und Pflegeprodukte sind zum Testen super! Ist halt immer ne Überraschung dabei aus Trendprodukten, von welchen ich vorher noch nicht gehört hatte.",
      },
      {
        name: "Stefanie G.",
        namePlatzhalter: false,
        datum: "2026-08-09",
        sterne: 5,
        text: "Tolle Produkte - ich liebe es jedes Mal, die Trendbox zu öffnen. Diese ist immer gefüllt mit Sachen, die man gut nutzen kann.",
      },
      {
        name: "Claudia H.",
        namePlatzhalter: false,
        datum: "2026-08-10",
        sterne: 5,
        text: "die Lieferung ging schnell und ich wsr sehr gespannt. Der Inhalt der Boxen hat mich überrascht, denn es waren wirklich viele Dinge darin, die man nicht kennt. Toll!!!",
      },
      {
        name: "Regina B.",
        namePlatzhalter: false,
        datum: "2026-08-10",
        sterne: 5,
        text: "Wieder eine gelungene Box! Gerade bei diesen heißen Sommertagen tolle Durstlöscher im Paket und die After-Sun-Pflege ist besonders gut.",
      },
      {
        name: "Rebecca W.",
        namePlatzhalter: false,
        datum: "2026-07-25",
        sterne: 5,
        text: "Bisher habe ich mich über jede Box gefreut und kann die neue Box kaum erwarten! Viele neue Marken auszuprobieren macht mir riesen Spaß. So lernt man vieles kennen und kann es ohne böse Überraschung nachkaufen.",
      },
      {
        name: "Ute Khadija S.",
        namePlatzhalter: false,
        datum: "2026-07-09",
        sterne: 5,
        text: "Ich liebe es jeden Monat überrascht zu werden, bisher war kein Paket eine Enttäuschung. Es macht Spaß immer wieder Neues zu entdecken.",
      },
      {
        name: "Kerstin F.",
        namePlatzhalter: false,
        datum: "2026-01-22",
        sterne: 5,
        text: "Einfach großartig diese Box — Bin begeistert vom Inhalt der ersten Box und schon sehr gespannt auf die Nächste. Produktvielfalt ist sehr gut und hochwertig.",
      },
    ],
  
    // Wie viele Bewertungen ohne Klick sichtbar sind. Der Rest kommt ueber den Knopf.
    reviewsSichtbar: 3,
  
    // STAND 25.08.2026: das Karussell zeigt nur noch die Monate, deren Warenwert
    // gerechnet ist - Juni und Juli. Februar bis Mai sind raus.
    //
    // Warum: Stephan (Einkauf) hat am 25.08. in #lp-offensive die Zaehlregel
    // beantwortet ("Warenwert aus Boxplan ... durch alle Artikel ohne Splitting,
    // inkl. Goodie"). Welche der ZWEI boxplan-Rechnungen er meint, verraet seine
    // eigene Zahl: 105,95 € ist auf den Cent der Box-HEADER-Wert fuer 2026-08.
    // Der Analyse-Tab summiert bei geteilten Slots ALLE Alternativen und kaeme
    // fuer 2026-09 auf 191,70 € statt 111,30 € - fast das Doppelte.
    //
    // Diese Regel auf Februar bis Mai anzuwenden geht nicht: die vier Box-Zeilen
    // existieren inzwischen in boxplan (der Befund vom 13.08., es gebe TRENDBOX-
    // Boxen erst ab Juni, ist ueberholt), haben aber NULL BoxAssignment - es ist
    // nichts da, was sich summieren liesse. Was existiert, ist HistoricalBoxStat,
    // am 25.04. von Hand eingetragen (Feb 114,38 / Mär 92,85 / Apr 121,20 /
    // Mai 85,98). In denselben Zeilen steht ein EK von 1,10-2,20 € pro Box - das
    // kann nicht stimmen, und wer beim EK danebenliegt, ist beim Warenwert nicht
    // belegt. Zwei der vier laegen ausserdem ueber der Willkommensbox selbst.
    //
    // Die Fotos der vier Monate sind echt und bleiben in TR_BILD stehen (Robin,
    // 19.08., der Dateiname traegt den Monat). Erfunden waren nur Wert und
    // Zusammensetzung. Bestaetigt jemand die vier Zahlen, kommen die Karten mit
    // je zwei Zeilen zurueck.
    //
    // Warenwert je Monat aus der Produktiv-DB (25.08., Header-Regel, ueber
    // /api/form/box-values - derselbe Endpunkt, der das Kuendigungsformular
    // speist): Juni 84,29 · Juli 88,80 · August 105,95 · September 111,30.
    //
    // 🚨 Der Sprung ueber 105 € kam erst im August. Juni und Juli liegen 21 bzw.
    // 17 € unter der "mind. 105 €"-Zusage, die weiter oben auf derselben Seite
    // steht - im Karussell steht sie damit sichtbar darunter. Ob das so bleibt,
    // haengt an Stephans Antwort (gefragt am 25.08.): ist August/September die
    // neue Norm, oder war Juni/Juli der Normalfall? Im zweiten Fall muss die
    // Zusage runter, und der Anker faellt von 171,45 € auf 151,45 €.
    //
    // 10.09.2026: August ist drin. Robin hat das Foto geliefert
    // (08-Trendbox-Endless-Summer-08-2026, gleiche Reihe wie Februar bis Juli),
    // TR_BILD deckt jetzt 2026-02 bis 2026-08 ab.
    //
    // Kein imageUrl-Feld hier (bewusst entfernt 11.08.2026, Review-Blocker 2/7):
    // die Zuordnung Monat -> Foto steht in TR_BILD im Prototyp-HTML, damit hier
    // niemand versehentlich ein Community-Foto als "so sah die Februar-Box aus"
    // einhaengt.
    // 25.08. 16:05: Wert-Badge im Karussell AUS. Grund ist keine Design-Laune,
    // sondern ein Widerspruch auf derselben Seite: seit Stephans Ansage wirbt die
    // Seite mit "mind. 100 €" fuer JEDE Monatsbox - Juni (84,29 €) und Juli
    // (88,80 €) liegen darunter. Solange beides sichtbar ist, widerlegt das
    // Karussell die Zusage drei Bildschirme weiter oben. Die Werte bleiben in den
    // Daten stehen (sie sind gerechnet und richtig, nur aelter als die Zusage);
    // ein true hier holt die Badges zurueck.
    //
    // Was die Karten weiter tragen: Foto der echten Box, Monat und Stueckzahl -
    // der Beweis "da ist wirklich was drin" bleibt, nur ohne Preisschild.
    trackRecordWertZeigen: false,
  
    trackRecord: [
      // 09.09.2026 (Alex): neueste Box zuerst. Vorher stand Juni vor Juli, damit
      // las sich die Reihe wie ein Archiv statt wie der aktuelle Beleg. Gilt auch
      // fuers Handy: die erste Karte im Streifen ist jetzt der juengste Monat.
      // Juli stand bis zum 25.08. mit 85,55 € hier - bewusst als UNTERGRENZE,
      // weil eine der 12 Positionen im Pipedrive-Deal keinen UVP hatte und mit 0
      // in die Summe ging. Der UVP ist inzwischen gepflegt, boxplan liefert
      // 88,80 €. Also kein Rechenfehler von damals, sondern eine geschlossene
      // Luecke - die Zahl durfte hoch.
      // 10.09.2026 BELEGT. Wert 105,95 € steht schon seit dem 25.08. oben in
      // diesem Block (Header-Regel ueber /api/form/box-values). Die
      // Zusammensetzung fehlte, weil Robin sie zum Foto nicht mitgeschickt hat -
      // sie ist deshalb aus der boxplan-Produktiv-DB gezaehlt, nach genau der
      // Regel, die auch den Warenwert rechnet (box-stats.ts): Flyer raus,
      // Goodies eigens, ein Produkt je Basis-Slot (floor(position)), damit
      // geteilte Slots nicht doppelt zaehlen.
      //   Slots 1-11, darunter 9.1/9.2 (Eistee Pfirsich ODER Zitrone) und
      //   11/11.2 (Maisflips ODER Tortilla Chips) -> 11 Produkte
      //   Goodie: Fusspflege-Oel -> 1
      //   Draussen: 2 Flyer (Promo) und 2 unplatzierte Zeilen ohne Slot.
      // Kontrollarm: dieselbe Abfrage fuer Juli liefert 10 Slots + 2 Goodies -
      // exakt das, was seit dem 13.08. auf der Karte steht. Die Regel ist also
      // die, aus der die bestehenden Karten stammen, nicht eine neue.
      {
        label: "August 2026",
        wert: 105.95,
        wertPlatzhalter: false,
        zusammensetzung: "11 Produkte + 1 Goodie",
      },
      {
        label: "Juli 2026",
        wert: 88.8,
        wertPlatzhalter: false,
        zusammensetzung: "10 Produkte + 2 Goodies",
      },
      // 13.08.2026 BELEGT, am 25.08. gegen die Produktiv-DB nachgeprueft. Lene
      // hat die drei Zaehlregeln beantwortet: (a) zwei Artikel auf derselben
      // Position -> der nicht-vegane zaehlt, (b) Goodies zaehlen zum Warenwert,
      // (c) Partner-UVP, nicht Shopify-Preis. Zur Kontrolle wurden beide
      // Regelwerke gerechnet - Lenes und boxplans eigenes (guenstigste
      // Alternative je Slot) - beide liefern fuer Juni denselben Wert.
      {
        label: "Juni 2026",
        wert: 84.29,
        wertPlatzhalter: false,
        zusammensetzung: "12 Produkte + 1 Goodie",
      },
    ],
  
    // "satz" ist Pflicht-Copy (Task 6, verbatim mit dem Kunden abgestimmt) -
    // nicht bloss ein Label, sondern der erklaerende Satz neben der Zahl.
    // Reihe "Jahre Trendbox" aus dem ersten Entwurf gestrichen: nicht belegt
    // und nicht im abgestimmten Brief - lieber 3 belegte + 1 offene Zahl als
    // eine zweite erfundene.
    // "key" macht die belegten Zeilen ausserhalb dieser Tabelle adressierbar
    // (data-wb-boxen/-rating/-bewertungen in der HTML-Datei) - "600.000+"/"4,5/5"/"6.966"
    // standen vorher zusaetzlich als eigene Literale in Trustbadge/Groesse/Reviews-Summary.
    //
    // KORREKTUR 12.08.2026: hier stand "4,8/5 aus 2.971 Bewertungen". Der
    // aggregate-rating-Endpoint der etrusted-API sagt an diesem Tag overall 4,48
    // aus 6.795 Bewertungen (365 Tage: 4,45 / 1.606 · 90 Tage: 4,58 / 496). Die
    // 4,8 waren also zu hoch UND die Anzahl zu niedrig - ein zu gutes Rating ist
    // der gefaehrlichere der beiden Fehler, weil jede Besucherin es beim Klick
    // aufs TS-Profil nachrechnen kann. Jetzt overall, auf eine Stelle gerundet.
    // Vor Live-Gang abgleichen, welchen Zeitraum das oeffentliche TS-Siegel zeigt
    // (TS stellt ueblicherweise die letzten 12 Monate dar) und ggf. darauf drehen.
    //
    // 10.09.2026 aufgefrischt (Alex): die 6.795 waren der Stand vom 12.08. und
    // damit einen Monat alt. aggregate-rating sagt heute overall 4,48 aus 6.966
    // Bewertungen -> Anzahl auf 6.966, die 4,5 bleiben (4,48 gerundet).
    // 🚨 Die Zahl waechst taeglich um ~6 Bewertungen. Sie ist ein Schnappschuss,
    // kein Wert, der ohne Pflege stimmt - vor dem Livegang nochmal ziehen, sonst
    // steht dort wieder eine Zahl von vorgestern.
    // 🚨 Und der oeffentliche Zeitraum ist NICHT derselbe: das TS-Siegel zeigt
    // ueblicherweise 12 Monate, dort stehen heute 4,49 aus 1.567 Bewertungen.
    // Wer auf der Seite "6.966" liest und dann aufs Siegel klickt, sieht 1.567.
    // Beides ist richtig, aber es erklaert sich nicht von selbst - das ist die
    // eigentliche offene Frage, nicht die Frische der Zahl.
    //
    // 14.09.2026 (Alex): Note 4,5 -> 4,6. Regel "immer aufrunden" auf die
    // 12-Monats-Note, die auch das Siegel zeigt (API 4,52 aus 1.471); so steht es
    // seit PR #286 im Metaobjekt trust/main und in der Shop-Topbar. Die Anzahl
    // bleibt bewusst die Gesamtzahl (6.985), Alex hat das so entschieden. Im Theme
    // kommen beide Werte live aus dem Metaobjekt (window.WB_TRUST), diese Zeile
    // ist nur noch der Stand fuer Prototyp und Vorschau.
    zahlen: [
      { key: "boxen", wert: "600.000+", satz: "Boxen haben wir bereits an Kundinnen in Deutschland geliefert.", belegt: true },
      { key: "rating", wert: "4,6/5", bewertungenAnzahl: "6.985", satz: "bewerten unsere Kundinnen uns bei Trusted Shops — aus 6.985 Bewertungen.", belegt: true },
      // 13.08.2026 von "8–10" auf "10+" korrigiert (Lene, #lp-offensive): es sind
      // immer MINDESTENS 10 Produkte. "Mind. 8, meistens 10" war eine Untertreibung
      // aus dem ersten Entwurf und hat die Box unter Wert verkauft.
      { key: "produkte", wert: "10+", satz: "Produkte stecken in jeder Monatsbox, im Warenwert von %%BOXWERT%%.", belegt: true },
      // 17.08.2026 von "4.500+ Abos laufen aktuell" auf die kumulative Zahl gedreht
      // (Alex). Gemessen am selben Tag ueber die Shopify-Admin-API,
      // /admin/api/2024-10/customers/count.json: 91.826 Kundendatensaetze => "90.000+".
      //
      // Warum NICHT "90.000 Mitglieder": das sind Kunden, keine Abonnentinnen - wer
      // einmal eine Geschenkbox gekauft hat, steckt mit drin. Die Abo-Historie gibt
      // die Zahl nicht her: seal_subscriptions_history kennt 16.070 verschiedene
      // E-Mails aus 19.687 Abos, reicht aber erst bis zum 07.12.2024 zurueck, und
      // trendraider_subscriptions ist nur der Alt-Restbestand ab 01/2026 (max. 1.788),
      // nicht die Historie von trendraider.de. Die Mitgliederzahl aus der TrendRaider-
      // Zeit liegt in keinem System, an das die reporting-DB kommt.
      //
      // So macht es auch das Vorbild: Goodiebox schreibt die grosse Zahl nie auf
      // "Mitglieder", sondern trennt "70.000+ Mitglieder erhalten unsere Box JEDEN
      // MONAT" (aktiv) von "10 Millionen+ Goodieboxen wurden bereits GELIEFERT"
      // (kumulativ, auf Boxen statt auf Menschen). Die kumulative Aussage bezieht
      // sich dort auf etwas, das kumulativ auch wirklich stimmt - genau deshalb
      // steht hier "Kundinnen" und nicht "Mitglieder".
      //
      // Aktive Abos, falls die Zahl doch wieder gebraucht wird: 4.961 am 11.08.2026
      // (subscriptions_daily, produkt=gesamt), davon 4.960 zahlend; 4.500+ war die
      // konservative Rundung, 4.900+ waere ebenfalls belegt gewesen.
      { key: "mitglieder", wert: "90.000+", satz: "Kundinnen haben schon bei uns bestellt.", belegt: true },
    ],
  
    marken: ["Lavera", "Tony's", "Wholey", "Waterdrop", "Rosental", "Bears with Benefits"],
  };

  /* ---- Copy-JSON einlesen ---- */
  // Eigener, isolierter Block NUR fuers Parsen: try/catch faengt einen kaputten JSON-Block ab,
    // damit ein Copy-Tippfehler hier nicht den preiskritischen Block (D/eur/Werte) oder andere
    // Sektionen mitreisst - nur die betroffenen Copy-Stellen bleiben dann leer, alles andere laeuft.
    let WB_COPY;
    try {
      WB_COPY = JSON.parse(document.getElementById("wb-copy").textContent);
    } catch (err) {
      console.error("wb-copy JSON ist kaputt - Copy im #wb-copy-Block pruefen:", err);
      WB_COPY = { appGuideTabs: [], faqItems: [], schrittInhalte: {} };
    }

  /* ---- Preise und Warenwerte ---- */
  const D = window.WB_DATA;
    // 14.09.2026: Trusted-Shops-Note und Anzahl. Im Theme setzt die Section
    // window.WB_TRUST aus dem Metaobjekt trust/main - dieselbe Quelle wie die
    // Shop-Topbar, damit LP und Topbar nicht wieder auseinanderlaufen (4,5 hier,
    // 4,6 dort). Im Prototyp gibt es kein Liquid, dort gelten die Werte aus
    // data.js. Die Note ist die 12-Monats-Note, aufgerundet; die Anzahl zaehlt
    // alle Bewertungen (Alex' Entscheidung). Nur wohlgeformte Werte uebernehmen,
    // sonst bleibt der Stand aus data.js stehen.
    (function () {
      const T = window.WB_TRUST;
      const z = D.zahlen.find((x) => x.key === "rating");
      if (!T || !z) return;
      const note = String(T.note == null ? "" : T.note).trim();
      if (/^\d,\d$/.test(note)) z.wert = note + "/5";
      const anzahl = parseInt(String(T.anzahl == null ? "" : T.anzahl).replace(/\D/g, ""), 10);
      if (anzahl > 0) {
        const neu = String(anzahl).replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        z.satz = z.satz.split(z.bewertungenAnzahl).join(neu);
        z.bewertungenAnzahl = neu;
      }
    })();
    // WB_COPY (Reiter/FAQ/Wizard/Track-Record-Copy) wird im eigenen try/catch-Block oben geparst,
    // bewusst NICHT hier - ein kaputter JSON-Block soll nie die Preis-Anzeige mitreissen.
    const eur = (n) => n.toFixed(2).replace(".", ",") + "\u00a0€";  // 21.08. (Lene): geschuetztes Leerzeichen, sonst rutscht das Eurozeichen allein in die naechste Zeile
    // 26.08. (Lene): "Bis zu 166,45 € Warenwert" -> "166 € Warenwert". Nachkommastellen an
    // einer Werbezahl lesen sich wie eine Rechnung. Abgerundet, nie aufgerundet: eine Zahl,
    // die groesser waere als der echte Warenwert, waere eine falsche Zusage.
    // ACHTUNG (Alex hat es so entschieden, 26.08.): die 166 € gelten nur mit dem
    // teuersten der sechs Sets. Genuss-Set -> 131,36 €. Der Flow zeigt in der
    // Zusammenfassung weiter den exakten Wert des GEWAEHLTEN Sets.
    const eurGanz = (n) => Math.floor(n) + "\u00a0€";
    const setwertMax = Math.max(...D.sets.map((s) => s.value));
  
    // ---- Warenwert der ERSTEN Box: zieht sich selbst nach (18.09.2026) ----
    // Michelle in #projekt-lp-offensive: in der Zusammenfassung stand "Erste
    // Trendbox 80,00", die Septemberbox traegt real 111,30 - "das heisst wir
    // unterschlagen hier ja 30 €. Der Warenwert zu dem was du letztendlich zahlst
    // ist ja so ein attraktiver Faktor."
    //
    // Die 80 sind nicht falsch, sie sind die Untergrenze, die der Einkauf fuer
    // JEDE Monatsbox zusagt (Stephan, 10.09.) - damit niemand die Seite beim
    // Monatswechsel anfassen muss. Sie bleiben deshalb ueberall stehen, wo von den
    // FOLGENDEN Boxen die Rede ist (FAQ, Zahlen-Band "in jeder Monatsbox"). Nur
    // fuer die Box, die im ersten Karton liegt, nennt die Seite jetzt den echten
    // Wert des laufenden Monats.
    //
    // Woher: boxplan rechnet ihn mit derselben Funktion, die auch das
    // Kuendigungsformular speist, und schreibt ihn taeglich 05:10 (Cron
    // lp-boxwert-sync) in das Shop-Metafeld trendbox.lp_boxwert. Das Theme gibt
    // ihn als window.WB_BOXWERT aus - serverseitig gerendert, damit auf der Seite
    // nicht erst die Untergrenze steht und eine Zehntelsekunde spaeter eine andere
    // Zahl. Im Prototyp laeuft kein Liquid: dort ist WB_BOXWERT undefined und die
    // Seite zeigt wie bisher die Untergrenze.
    //
    // Der hinterlegte Monat MUSS der laufende sein. Das ist die Bremse gegen die
    // stille Variante des Fehlers: stirbt der Cron, friert die Zahl sonst auf dem
    // Wert einer Box ein, die laengst niemand mehr bekommt. Lieber die ehrliche
    // Untergrenze als eine falsche Genauigkeit.
    const boxwertLive = (() => {
      try {
        const b = window.WB_BOXWERT;
        if (!b || typeof b.wert !== "number" || !isFinite(b.wert) || b.wert <= 0) return null;
        // Unter der Zusage schreibt der Cron gar nicht erst - hier dieselbe Regel
        // noch einmal, damit eine von Hand gesetzte Zahl im Shopify-Admin nicht
        // "Erste Trendbox 75,00" ueber ein "Warenwert mind. 80" derselben Seite
        // schreiben kann.
        if (b.wert < D.willkommensbox.wert) return null;
        // sv-SE formatiert als ISO ("2026-09-18") - kuerzester Weg zu einem
        // Monatsvergleich in Berliner Zeit.
        const jetzt = new Date().toLocaleDateString("sv-SE", { timeZone: "Europe/Berlin" }).slice(0, 7);
        return b.monat === jetzt ? b : null;
      } catch (err) {
        return null;
      }
    })();
    const ersteBoxWert = boxwertLive ? boxwertLive.wert : D.willkommensbox.wert;
    const gesamt = setwertMax + ersteBoxWert;
    // 25.08. (Stephan): der Warenwert der Box ist keine Momentaufnahme mehr, sondern eine
    // Untergrenze, die jeden Monat haelt. Sie wird deshalb anders geschrieben als ein
    // exakter Betrag: "mind. 105 €" statt "105,00 €" - Nachkommastellen an einer Untergrenze
    // behaupten eine Genauigkeit, die es nicht gibt. Der Text steht an EINER Stelle, damit
    // die drei Fundstellen (Ablauf-Schritt 2, Angebotskarte, FAQ) nicht auseinanderlaufen.
    const boxwertText = D.willkommensbox.wertIstUntergrenze
      ? "mind. " + (Number.isInteger(D.willkommensbox.wert) ? String(D.willkommensbox.wert) + " €" : eur(D.willkommensbox.wert))
      : eur(D.willkommensbox.wert);
  
    document.querySelectorAll("[data-wb-preis]").forEach((e) => (e.textContent = eur(D.preis.monat)));
    document.querySelectorAll("[data-wb-gesamtwert]").forEach((e) => (e.textContent = eurGanz(gesamt)));
    document.querySelectorAll("[data-wb-setwert-max]").forEach((e) => (e.textContent = eurGanz(setwertMax)));
    document.querySelectorAll("[data-wb-boxwert]").forEach((e) => (e.textContent = boxwertText));
    // Zwei Aussagen, zwei Texte: boxwertText ist die Zusage fuer jede kommende Box
    // ("mind. 80 €"), boxwertErsteText der Wert der Box, die in der ersten Sendung
    // liegt. Ohne Live-Wert sagen beide dasselbe - dann aber auch als Untergrenze
    // geschrieben und nicht als "80,00 €", was wie eine Messung aussieht.
    const boxwertErsteText = boxwertLive ? eur(ersteBoxWert) : boxwertText;
    document.querySelectorAll("[data-wb-boxwert-erste]").forEach((e) => (e.textContent = boxwertErsteText));
    document.querySelectorAll("[data-wb-setanzahl]").forEach((e) => (e.textContent = String(D.sets.length)));
    document.querySelectorAll("[data-wb-produkte]").forEach((e) => (e.textContent = D.willkommensbox.produkte));
  
    // Boxenzahl und Rating standen bisher zusaetzlich zur zahlen-Tabelle noch als
    // eigene Literale in Trustbadge/Groesse/Reviews-Summary - ueber D.zahlen[].key
    // adressierbar gemacht, damit eine Aenderung nicht an vier Stellen gepflegt wird.
    const zBoxen = D.zahlen.find((z) => z.key === "boxen");
    const zRating = D.zahlen.find((z) => z.key === "rating");
    if (zBoxen) document.querySelectorAll("[data-wb-boxen]").forEach((e) => (e.textContent = zBoxen.wert));
  
    // 09.09. (Alex): die drei Belege in der Groessen-Karte kommen aus D.zahlen, nicht
    // aus abgetippten Literalen - sonst steht dieselbe Zahl auf der Seite zweimal und
    // wird nur an einer Stelle nachgezogen.
    const BELEGE = [
      { key: "rating", text: "bei Trusted Shops" },
      { key: "mitglieder", text: "Kundinnen haben bestellt" },
      { key: "produkte", text: "Produkte in jeder Box" },
    ];
    document.querySelectorAll("[data-wb-belege]").forEach((ziel) => {
      ziel.innerHTML = BELEGE.map((b) => {
        const z = D.zahlen.find((x) => x.key === b.key);
        return z ? `<div class="g-beleg"><b>${z.wert}</b><small>${b.text}</small></div>` : "";
      }).join("");
    });
    if (zRating) {
      document.querySelectorAll("[data-wb-rating]").forEach((e) => (e.textContent = zRating.wert));
      document.querySelectorAll("[data-wb-bewertungen]").forEach((e) => (e.textContent = zRating.bewertungenAnzahl));
      // Das Siegel ist role="img" - sein aria-label ist der einzige Text, den ein
      // Screenreader hoert, und stand als Literal "4,8 von 5" im Markup. Genau so
      // entsteht eine Note, die zwei Jahre spaeter niemand mehr nachzieht.
      const noteVorSlash = String(zRating.wert).split("/")[0];
      // Die Bar zeigt nur die Note ("4,5"), nicht "4,5/5" - neben den Sternen waere
      // der Nenner doppelt gemoppelt und die Bar ist die schmalste Flaeche der Seite.
      document.querySelectorAll("[data-wb-rating-kurz]").forEach((e) => (e.textContent = noteVorSlash));
      document.querySelectorAll("[data-wb-rating-label]").forEach((e) =>
        e.setAttribute("aria-label", `${noteVorSlash} von 5 Sternen bei Trusted Shops`));
      // Sternreihe aus der Note fuellen. Vorher standen hier fuenf volle Sterne als
      // Literal - neben "4,8/5" faellt das kaum auf, neben "4,5/5" behauptet die
      // Grafik eine bessere Note als die Zahl direkt daneben.
      const note = parseFloat(noteVorSlash.replace(",", "."));
      if (!Number.isNaN(note)) {
        const anteil = Math.max(0, Math.min(1, note / 5)) * 100;
        document.querySelectorAll("[data-wb-rating-sterne]").forEach((e) => (e.style.width = anteil + "%"));
      }
    }

  /* ---- Landingpage: Beweis-Sektionen, Marken, FAQ, Footer ---- */
  if (istLP) {
  /* ---------- Beweis-Sektionen (Task 6): ugc-strip, marken, reviews, zahlen, track-record ---------- */
  
    // Alt-Texte beschreiben echte Fotos echter Kundinnen (Juni-Trendbox-Posts + ein
    // "Beautybox Mai"-Post, siehe ugc-manifest.json) - bewusst NICHT "Willkommensbox",
    // die Fotos zeigen keine Willkommensbox (dieselbe Regel wie bei trackRecord.imageUrl
    // in der -data.js: echte Community-Fotos duerfen nicht als Beleg fuer eine konkrete,
    // nicht gezeigte Box verkauft werden).
    const UGC_STRIP = [
      { file: "ig_17.jpg", user: "lucianaa.b.a", alt: "Trendbox mit Produkten aus Food, Beauty und Wellness vor der Box aufgebaut" },
      { file: "ig_21.jpg", user: "joma_ellie", alt: "Geschlossene Trendbox mit Fliederzweigen auf dem Tisch" },
      { file: "ig_08.jpg", user: "tester.lady_", alt: "Kundin hält ein Produkt aus ihrer Trendbox in die Kamera" },
      { file: "ig_11.jpg", user: "one_vegan_mom", alt: "Trendbox-Fund drapiert auf dem Bett, Handyfoto-Stil" },
      { file: "ig_16.jpg", user: "kathrinsweltundso", alt: "Geöffnete Trendbox mit Blick von oben auf den Inhalt" },
      { file: "ig_00.jpg", user: "liliana94deea", alt: "Flatlay von Trendbox-Produkten auf hellem Untergrund" },
      // 17.09. (Michelle: "noch 1 Beitragsbild ergänzen, auf Desktop sieht das sonst
      // nicht aus"): siebtes Foto, damit die Reihe am Desktop die volle Breite fuellt.
      { file: "ig_22.jpg", user: "inspired.by.veronika", alt: "Kundin zeigt lachend ihre Trendbox in die Kamera" },
    ];
    document.querySelector("[data-ugc-track]").innerHTML = UGC_STRIP.map(
      (u) => `<figure class="strip-item"><img src="${wbAsset("wb-ugc-" + u.file)}" alt="${u.alt}" loading="lazy"><span>@${u.user}</span></figure>`
    ).join("");
  
    // 14.09. (Dennis' Punkt 06): Set-Fotos im Angebots-Block. Gleiche Quelle wie die
    // Set-Karten im Auswahl-Flow (s.bild, Rueckfall auf das erste Produktfoto), damit
    // beide Stellen nie verschiedene Bilder zeigen. Der Set-Name steht nur im alt-Text:
    // die Reihe soll zeigen, nicht erklaeren - die Namen liest man im Flow.
    document.querySelector("[data-offer-sets]").innerHTML = window.WB_DATA.sets.map(
      (s) => `<figure class="offer-set"><img src="${s.bild || s.items[0].imageUrl}" alt="Geschenk-Set ${s.name}" loading="lazy"></figure>`
    ).join("");
  
    // Indikator-Logik fuer beide Streifen (UGC oben, Community unten). War vorher auf den
    // oberen Streifen fest verdrahtet; der Community-Streifen wird erst weiter unten
    // gerendert, deshalb nimmt bindStripIndicator() den Aufhaenger entgegen statt ihn
    // selbst zu suchen, und wird dort ein zweites Mal aufgerufen.
    function bindStripIndicator(scroller, fill) {
      if (!scroller || !fill) return;
      function update() {
        const max = scroller.scrollWidth - scroller.clientWidth;
        const pct = max > 0 ? (scroller.scrollLeft / max) * 100 : 0;
        const visiblePct = Math.max(15, (scroller.clientWidth / scroller.scrollWidth) * 100);
        fill.style.width = visiblePct + "%";
        fill.style.marginLeft = pct * (1 - visiblePct / 100) + "%";
      }
      scroller.addEventListener("scroll", update);
      update();
    }
    window.__bindStripIndicator = bindStripIndicator;
    bindStripIndicator(document.querySelector(".strip-scroll"), document.querySelector("[data-strip-fill]"));
  
    /* Marken: echte, bereits auf trend-box.de genutzte Logo-Assets je Markenname (siehe tb-bestseller-c.html) */
    /* 20.08.: beschnittene Fassungen statt der CDN-URLs. Die Shop-Dateien liegen auf
       quadratischem Rahmen mit bis zu 79% leerem Alphakanal - jede Groessenangabe im
       CSS galt dadurch dem Rahmen, nicht dem Logo (siehe Kommentar bei .marken-karte).
       Quelle bleibt dasselbe Asset, nur auf den Alphakanal zugeschnitten. In Shopify
       wird daraus ein Bild-Setting je Marke; die Zuschnitte gehoeren dort in die
       Dateien, nicht ins CSS. */
    const MARKEN_LOGOS = {
      "Lavera": wbAsset("wb-marke-lavera.png"),
      "Tony's": wbAsset("wb-marke-tonys.png"),
      "Wholey": wbAsset("wb-marke-wholey.png"),
      "Waterdrop": wbAsset("wb-marke-waterdrop.png"),
      "Rosental": wbAsset("wb-marke-rosental.png"),
      "Bears with Benefits": wbAsset("wb-marke-bears.png"),
    };
    document.querySelector("[data-marken-row]").innerHTML = D.marken
      .map((name) => `<div class="marken-karte"><img src="${MARKEN_LOGOS[name] || ""}" alt="${name}" loading="lazy"></div>`)
      .join("");
  
    /* Reviews */
    function reviewInitialen(r) {
      if (r.namePlatzhalter) return "?";
      return r.name.split(" ").map((p) => p[0]).join("").slice(0, 2).toUpperCase();
    }
    function reviewDatum(iso) {
      const [y, m, d] = iso.split("-");
      return `${d}.${m}.${y}`;
    }
    // Die ersten D.reviewsSichtbar Karten stehen offen, der Rest haengt hinter dem
    // Knopf (Robin 13.08.: der tat vorher nichts). Alle Karten werden gerendert und
    // nur ausgeblendet - so gibt es kein Nachladen und der Knopf kann nicht ins
    // Leere greifen, wenn spaeter jemand die Liste kuerzt.
    const REVIEWS_OFFEN = D.reviewsSichtbar || 3;
    // 17.09. (Michelle): immer von neu nach alt, egal in welcher Reihenfolge die
    // Bewertungen in der Daten-Datei stehen. ISO-Datum sortiert als Text richtig.
    document.querySelector("[data-review-grid]").innerHTML = D.reviews
      .slice()
      .sort((a, b) => b.datum.localeCompare(a.datum))
      .map(
        (r, i) => `
        <article class="review-karte${i >= REVIEWS_OFFEN ? " ist-versteckt" : ""}"${i >= REVIEWS_OFFEN ? " hidden" : ""}>
          <div class="review-kopf">
            <div class="review-wer">
              <span class="review-avatar${r.namePlatzhalter ? " pl" : ""}">${reviewInitialen(r)}</span>
              <span class="review-name">${r.namePlatzhalter ? `<span class="pl" data-placeholder="true">${r.name}</span>` : r.name}<small>DE · Bewertung bei Trusted Shops</small></span>
            </div>
            <span class="review-datum">${reviewDatum(r.datum)}</span>
          </div>
          <p class="review-text">${r.text}</p>
          <div class="review-fuss">
            <span class="review-sterne" aria-hidden="true">${"★".repeat(r.sterne)}</span>
            <span class="review-verifiziert">✓ Verifiziert</span>
          </div>
        </article>`
      )
      .join("");
  
    (function () {
      const knopf = document.querySelector(".btn-mehr-bewertungen");
      if (!knopf) return;
      const versteckte = () => Array.from(document.querySelectorAll(".review-karte.ist-versteckt"));
      const rest = D.reviews.length - REVIEWS_OFFEN;
      if (rest <= 0) {
        // Kein Rest zum Aufklappen: dann steht da lieber kein Knopf als ein toter.
        knopf.hidden = true;
        return;
      }
      knopf.textContent = `Mehr Bewertungen lesen (${rest})`;
      knopf.setAttribute("aria-expanded", "false");
      knopf.addEventListener("click", () => {
        const auf = knopf.getAttribute("aria-expanded") === "true";
        versteckte().forEach((k) => (k.hidden = auf));
        knopf.setAttribute("aria-expanded", String(!auf));
        knopf.textContent = auf ? `Mehr Bewertungen lesen (${rest})` : "Weniger anzeigen";
      });
    })();
  
    /* Zahlen */
    // %%BOXWERT%% im Satz wird hier aufgeloest, damit der Warenwert auch im
    // Zahlen-Band aus derselben Quelle kommt wie in Ablauf, Angebot und FAQ.
    // Bis zum 25.08. stand dort die feste Spanne "80 bis 100 €" - die ist auf
    // Stephans Ansage raus, weil schon die Augustbox mit 105,95 € darueber liegt.
    const zSatz = (z) => z.satz.replace(/%%BOXWERT%%/g, boxwertText);
    document.querySelector("[data-zahlen-tabelle]").innerHTML = D.zahlen
      .map(
        (z) => `
        <div class="zahlen-zeile">
          <b class="zahlen-zahl">${z.belegt ? z.wert : `<span class="pl" data-placeholder="true">${z.wert}</span>`}</b>
          <span class="zahlen-satz">${z.belegt ? zSatz(z) : `<span class="pl" data-placeholder="true">${zSatz(z)}</span>`}</span>
        </div>`
      )
      .join("");
  
    /* Track-Record — Motiv-Texte kommen aus dem #wb-copy-JSON-Block (siehe Kommentar dort) */
    // Zuordnung ueber das Label, nicht ueber den Index: Robins Dateinamen tragen den
    // Monat ("05-...-05-2026"), und eine Label-Map stimmt auch dann noch, wenn
    // trackRecord umsortiert oder um einen Monat erweitert wird.
    // Februar bis Mai stehen hier weiter drin, obwohl trackRecord sie am 25.08.
    // verloren hat: die Fotos sind echt, nur die Werte waren es nicht (siehe den
    // langen Kommentar im Daten-File). Bestaetigt jemand die vier Zahlen, reicht
    // ein Eintrag in trackRecord - das Bild haengt dann von allein wieder dran.
    const TR_BILD = {
      "Februar 2026": wbAsset("wb-box-2026-02.jpg"),
      "März 2026":    wbAsset("wb-box-2026-03.jpg"),
      "April 2026":   wbAsset("wb-box-2026-04.jpg"),
      "Mai 2026":     wbAsset("wb-box-2026-05.jpg"),
      "Juni 2026":    wbAsset("wb-box-2026-06.jpg"),
      "Juli 2026":    wbAsset("wb-box-2026-07.jpg"),
      "August 2026":  wbAsset("wb-box-2026-08.jpg"),
    };
    document.querySelector("[data-tr-track]").innerHTML = D.trackRecord
      .map(
        (b) => `
        <article class="tr-card">
          <div class="tr-foto"><img src="${TR_BILD[b.label] || ""}" alt="Inhalt der Trendbox ${b.label}" loading="lazy">
            <span class="tr-bubble">${b.label}</span>
            ${D.trackRecordWertZeigen ? `<span class="tr-badge${b.wertPlatzhalter ? " pl" : ""}"${b.wertPlatzhalter ? ' data-placeholder="true"' : ""}>${b.wertPlatzhalter ? "Wert: XX&nbsp;€" : `Wert: ${eur(b.wert)}`}</span>` : ""}
          </div>
          <div class="tr-caption">
            <span>${b.wertPlatzhalter ? `<span class="pl" data-placeholder="true">${b.zusammensetzung}</span>` : b.zusammensetzung}</span>
          </div>
        </article>`
      )
      .join("");
  
    const trTrack = document.querySelector("[data-tr-track]");
    const trCards = () => Array.from(trTrack.querySelectorAll(".tr-card"));
    // Fortschrittsbalken statt Monats-Kreise (Lene 13.08.) - dieselbe Mechanik wie
    // bei den beiden Foto-Streifen, der Monat steht jetzt als Bubble auf dem Bild.
    window.__bindStripIndicator(trTrack, document.querySelector("[data-tr-fill]"));
  
    function trAktiverIndex() {
      const mitte = trTrack.scrollLeft + trTrack.clientWidth / 2;
      let idx = 0;
      let minDist = Infinity;
      trCards().forEach((c, i) => {
        const dist = Math.abs(c.offsetLeft + c.offsetWidth / 2 - mitte);
        if (dist < minDist) {
          minDist = dist;
          idx = i;
        }
      });
      return idx;
    }
  
    const trPrev = document.querySelector("[data-tr-prev]");
    const trNext = document.querySelector("[data-tr-next]");
    trPrev.addEventListener("click", () => {
      const c = trCards()[Math.max(0, trAktiverIndex() - 1)];
      if (c) c.scrollIntoView({ behavior: "smooth", inline: "start", block: "nearest" });
    });
    trNext.addEventListener("click", () => {
      const c = trCards()[Math.min(trCards().length - 1, trAktiverIndex() + 1)];
      if (c) c.scrollIntoView({ behavior: "smooth", inline: "start", block: "nearest" });
    });
    // wie der Theme-Slider: Pfeil am Anfang/Ende ausgegraut (03.10.2026)
    const trStand = () => {
      const max = trTrack.scrollWidth - trTrack.clientWidth;
      trPrev.classList.toggle("disabled", trTrack.scrollLeft <= 4);
      trNext.classList.toggle("disabled", trTrack.scrollLeft >= max - 4);
    };
    trTrack.addEventListener("scroll", trStand, { passive: true });
    window.addEventListener("resize", trStand);
    trStand();
  
  
    /* ---------- Marken-Panel, Groesse, Community-Streifen, FAQ, Footer (Task 8) ---------- */
  
    /* Marken-Panel: dieselben Marken wie oben (D.marken / MARKEN_LOGOS aus dem Beweis-Block).
       Bis 12.08. lagen sie hier auf absoluten Prozent-Slots mit Rotation verstreut; das ist
       mitsamt der Slot-Liste raus, weil das Raster die Verteilung jetzt selbst macht (CSS
       grid, 3 Spalten) und mit jeder Markenzahl klarkommt statt nur mit genau sechs. */
    /* 15.09.: das Panel ist auf Lenes Rueckmeldung aus dem Markup raus (doppelt mit dem
       Marken-Streifen). Abgesichert statt geloescht: der Theme-Build findet diesen
       Script-Block ueber den Marker data-marken-panel-logos und zaehlt die Bloecke. */
    const markenPanel = document.querySelector("[data-marken-panel-logos]");
    if (markenPanel) markenPanel.innerHTML = D.marken
      .map((name) => `<div class="marken-panel-logo"><img src="${MARKEN_LOGOS[name] || ""}" alt="${name}" loading="lazy"></div>`)
      .join("");
  
    /* 09.09. (Michelle): Beautybox-Fotos (ig_01, 02, 04, 05 - rosa/rote "BEAUTY BOX") raus, nur Trendbox.
       Community-Streifen: bewusst andere Bilder als ugc-strip (00,08,09,11,14,16,17,19,21)
       und zahlen-collage (04,09,14,19), damit sich die Seite nicht wiederholt.
       Alt-Texte wie im UGC-Strip (siehe Kommentar dort) NICHT "Willkommensbox" - laut
       ugc-manifest.json sind auch diese sieben Fotos Mai/Juni-Trendbox-Posts echter,
       namentlich bekannter Personen, keine Willkommensbox (Nachtrag 11.08.2026, Review). */
    const COMMUNITY_STRIP = [
      { file: "ig_20.jpg", user: "madalina.bell", alt: "Kundin hält lachend ihre Trendbox im Arm" },
      { file: "ig_03.jpg", user: "just.beatsi", alt: "Trendbox-Inhalt ausgebreitet auf einer Picknickdecke im Freien" },
      { file: "ig_23.jpg", user: "alues_buecherparadies", alt: "Kundin liest das Trendbox-Magazin, die geöffnete Box auf dem Schoß" },
      { file: "ig_10.jpg", user: "aboutnice_mom_things", alt: "Trendbox-Karton mit Inhalt auf der Küchenarbeitsplatte" },
      { file: "ig_13.jpg", user: "oprea.veronica", alt: "Kundin zeigt ihre Trendbox-Produkte vor dem Badezimmerspiegel" },
      { file: "ig_15.jpg", user: "naturknoten", alt: "Trendbox-Fund in Nahaufnahme bei natürlichem Licht" },
      { file: "ig_18.jpg", user: "_nad_ine_85_", alt: "Kundin teilt einen Story-Ausschnitt ihrer frisch angekommenen Trendbox" },
    ];
    document.querySelector("[data-community-track]").innerHTML = COMMUNITY_STRIP.map(
      (u, i) => `<figure class="community-item${i % 2 ? " tief" : ""}"><img src="${wbAsset("wb-ugc-" + u.file)}" alt="${u.alt}" loading="lazy"></figure>`
    ).join("");
    window.__bindStripIndicator(
      document.querySelector(".community-strip"), document.querySelector("[data-community-fill]"));
  
    /* FAQ: Copy verbatim aus dem Task-Brief.
       Bis 12.08. waren die ersten vier Antworten offen vorgerendert. Alex hat am 12.08.
       entschieden, alle einzuklappen — wie im Vorbild, wo alle neun zu sind.
       Gegenargument bleibt aktenkundig: der Wayback-Diff der alten Bestseller-LP zeigte,
       dass eingeklappte Antworten zu "kann ich einmalig testen" und "wie kuendige ich"
       mit dem CR-Einbruch korrelierten. Wenn der Test unentschieden ausgeht, ist das
       hier die erste Variable, an der man dreht: FAQ_OFFEN_BIS_INDEX auf 3 zurueck. */
    // FAQ-Copy kommt aus dem #wb-copy-JSON-Block (siehe Kommentar dort) - verbatim aus dem Task-Brief
    const FAQ_ITEMS = WB_COPY.faqItems;
    const FAQ_OFFEN_BIS_INDEX = -1; // -1 => alle Antworten eingeklappt (siehe Kommentar oben)
  
    // FAQ-Antworten koennen %%TOKEN%%-Platzhalter enthalten (siehe #wb-copy-JSON-Block).
    // Direkte data-wb-*-Attribute gehen hier nicht: die Werte-Population oben laeuft
    // einmalig beim Laden, bevor die FAQ-Liste ueberhaupt ins DOM gerendert ist - ein
    // data-wb-gesamtwert-Span in der FAQ-Antwort bliebe leer. Deshalb Text-Ersetzung
    // beim Rendern, ueber dieselben Werte (D, eur, gesamt), die auch die data-wb-*-
    // Attribute speisen - eine Preisaenderung propagiert weiterhin ueberallhin gleich.
    function interpoliereFaq(text) {
      return text
        .replace(/%%GESAMTWERT%%/g, eurGanz(gesamt))
        .replace(/%%PREIS%%/g, eur(D.preis.monat))
        .replace(/%%BOXWERT%%/g, boxwertText)
        .replace(/%%PRODUKTE%%/g, D.willkommensbox.produkte)
        .replace(/%%SETANZAHL%%/g, String(D.sets.length));
    }
  
    document.querySelector("[data-faq-list]").innerHTML = FAQ_ITEMS.map((item, i) => {
      const offen = i <= FAQ_OFFEN_BIS_INDEX;
      return `
      <div class="faq-item">
        <h3 class="faq-q">
          <button type="button" class="faq-btn" id="faq-btn-${i}" aria-expanded="${offen}" aria-controls="faq-panel-${i}">
            <span>${item.frage}</span>
            <span class="faq-plus" aria-hidden="true"></span>
          </button>
        </h3>
        <div class="faq-panel" id="faq-panel-${i}" role="region" aria-labelledby="faq-btn-${i}"${offen ? "" : " hidden"}>
          <p>${interpoliereFaq(item.antwort)}</p>
        </div>
      </div>`;
    }).join("");
  
    document.querySelector("[data-faq-list]").addEventListener("click", (e) => {
      const btn = e.target.closest(".faq-btn");
      if (!btn) return;
      const offen = btn.getAttribute("aria-expanded") === "true";
      const panel = document.getElementById(btn.getAttribute("aria-controls"));
      btn.setAttribute("aria-expanded", String(!offen));
      if (panel) panel.hidden = offen;
    });
  }

  /* ---- Zwei echte Seiten statt zweier Ansichten ----
     Der Prototyp schaltete per History-API zwischen LP und Flow um. Im Theme
     sind es zwei Templates, der Wechsel ist ein normaler Link. Bleibt: den
     Herkunfts-Parameter mitnehmen, sonst ist im Reporting nicht zu trennen,
     welche Landingpage den Kauf gebracht hat. */
  document.addEventListener("click", function (e) {
    var hin = e.target.closest('a[href="#wizard"], a[href="#/flow"], [data-zur-flow]');
    if (hin) {
      e.preventDefault();
      window.location.href = WB_URL.flow || "/pages/willkommensbox-auswahl?ref=lp-willkommensbox";
      return;
    }
    if (e.target.closest("[data-flow-zurueck]")) {
      e.preventDefault();
      // Wer ueber den CTA kam, hat einen Verlaufseintrag - dann raeumt back()
      // auch die Adresszeile auf. Wer direkt hier landet (geteilter Link,
      // Meta-Anzeige), hat keinen: der wuerde von back() aus dem Shop fliegen.
      if (document.referrer && document.referrer.indexOf(window.location.host) > -1) {
        history.back();
      } else {
        window.location.href = WB_URL.lp || "/pages/willkommensbox";
      }
    }
  });

  /* ---- Klebende Kaufleiste ----
     Faehrt ein, sobald der Hero-Knopf aus dem Blick ist. Im Prototyp war <main>
     der Scroll-Container und damit der Bezugsrahmen; im Theme scrollt das
     Fenster, also root: null. Mit dem alten Bezug feuert der Beobachter nie und
     die Leiste bliebe fuer immer unsichtbar. */
  if (istLP) {
    var heroKnopf = document.querySelector(".hero-aktion .cta");
    var leiste = document.querySelector("[data-sticky-cta]");
    if (heroKnopf && leiste && "IntersectionObserver" in window) {
      new IntersectionObserver(function (e) {
        leiste.classList.toggle("ist-sichtbar", !e[0].isIntersecting);
      }, { root: null, threshold: 0 }).observe(heroKnopf);
    }
  }

  /* ---- Auswahl-Flow (3 Schritte) ---- */
  if (istFlow) {
  /* ---------- Wizard: Zustand ---------- */
    const wbState = {
      schritt: 1,
      set: null,
      // welches Set gerade seinen Inhalt zeigt (13.08., siehe setKarte). Immer nur
      // eines - sonst ist die Wand aus Produktzeilen sofort wieder da.
      setOffen: null,
    };
    window.__wbState = wbState;
  
    /* 4 -> 5 (17.08.): vorne kommt ein Uebersichtsschritt dazu. Das Vorbild macht es
       genauso (dort "1/5") und Robin hatte am 13.08. genau diesen Screenshot
       angehaengt - seine offene Rueckfrage ist damit beantwortet. Der Schritt
       verlangt keine Eingabe, er zeigt nur, woraus das Paket besteht: wer von der
       Landingpage kommt, landet sonst uebergangslos in einer Produktauswahl. */
    /* 08.09. (Michelle): 5 -> 3. Die Vorlieben-Schritte (Lieblingsprodukte, Ernaehrung,
       Hauttyp) sind raus - wer das Genuss-Set waehlt, hat seine Vorliebe schon gezeigt,
       und der Weg zur Kasse war zu lang. Uebersicht -> Set -> Zusammenfassung. */
    const SCHRITTE = 3;
  
    function weiterErlaubt() {
      if (wbState.schritt === 2) return wbState.set !== null;
      return true; // Uebersicht: nichts zu waehlen; letzter Schritt hat keinen Weiter-Button
    }
  
    function geheZu(n) {
      wbState.schritt = Math.min(Math.max(n, 1), SCHRITTE);
      render();
      document.querySelector("#wizard").scrollIntoView({ behavior: "smooth", block: "start" });
    }
  
    /* ---------- dataLayer ---------- */
    window.dataLayer = window.dataLayer || [];
  
    function wbEvent(name, extra = {}) {
      window.dataLayer.push({
        event: name,
        wizard_schritt: wbState.schritt,
        wizard_set: wbState.set,
        ...extra,
      });
    }
  
    /* ---------- Inhalte ---------- */
  
    // Wizard-Schritt-Copy kommt aus dem #wb-copy-JSON-Block (siehe Kommentar dort)
    const SCHRITT_INHALTE = WB_COPY.schrittInhalte;
  
    function findSet(key) {
      return D.sets.find((s) => s.key === key);
    }
  
    // Die Produktliste haengt seit dem 13.08. hinter einem Schalter (Robin: "die
    // folgenden Produkte muessen erst in einer gesonderten Auswahl auftauchen").
    // Vorher standen auf allen sechs Karten gleichzeitig alle Einzelartikel mit
    // Preis - Schritt 1 war eine Wand aus ~22 Zeilen Kleingedrucktem, durch die man
    // sich lesen musste, bevor ueberhaupt klar war, dass man EINE Karte waehlt.
    // Jetzt zeigt die Karte Bild, Name, Stueckzahl und Wert; der Inhalt kommt auf
    // Wunsch. Der Schalter ist ein eigener Button mit stopPropagation, sonst waehlt
    // ein Blick in den Inhalt das Set gleich mit aus.
    function setKarte(s) {
      const produkte = s.items
        .map((i) => `<li><span>${i.vendor} · ${i.title}</span><b>${eur(i.priceEur)}</b></li>`)
        .join("");
      const offen = wbState.setOffen === s.key;
      const anzahl = s.items.length;
      return `
        <article class="set-karte${s.verfuegbar ? "" : " ist-weg"}${s.key === wbState.set ? " ist-gewaehlt" : ""}"
                 data-set="${s.key}"
                 ${s.verfuegbar ? 'tabindex="0" role="button"' : 'aria-disabled="true"'}>
          <div class="set-bild" style="background-image:url('${s.bild || s.items[0].imageUrl}')"></div>
          <h4>${s.name}</h4>
          <p class="set-wert"><span class="set-anzahl">${anzahl} Produkte</span> · Warenwert <b>${eur(s.value)}</b></p>
          <button type="button" class="set-inhalt-schalter" data-set-inhalt="${s.key}" aria-expanded="${offen}">
            ${offen ? "Inhalt ausblenden" : "Inhalt ansehen"}
          </button>
          <ul class="set-produkte"${offen ? "" : " hidden"}>
            <li class="set-produkte-kopf"><span>Enthalten</span><b>UVP</b></li>
            ${produkte}</ul>
          ${s.verfuegbar ? "" : '<span class="set-weg-label">Gerade ausverkauft</span>'}
        </article>`;
    }
  
  
  
    /* ---------- Schritt-Inhalte ---------- */
    function schritt1Inhalt() {
      return `<div class="set-grid">${D.sets.map(setKarte).join("")}</div>`;
    }
  
  
  
    /* Der Geburtstags-Schritt ist am 17.08. entfallen (Alex: "Conversion-Killer").
       Er stand als vierter von fuenf Schritten zwischen der Geschmacks-Abfrage und
       der Uebersicht - ein Pflichtblick auf ein Datumsfeld, das fuer die erste
       Lieferung nichts entscheidet und dessen Nutzen (+30 Punkte) erst nach dem Kauf
       eintritt. Der Geburtstag laesst sich spaeter im Mitglieder-Konto nachtragen,
       ohne hier Tempo zu kosten. Der Wizard hat dadurch vier statt fuenf Schritte;
       die Uebersicht ist jetzt Schritt 4. */
    function schritt4Inhalt() {
      const s = findSet(wbState.set);
      // ersteBoxWert statt der Untergrenze: hier steht die Box, die mit diesem
      // Klick in den Karton geht - und daneben ein exakter Set-Wert auf den Cent.
      // Genau diese Karte hat Michelle am 18.09. aufgemacht ("wir unterschlagen
      // hier ja 30 €"): "80,00 €" las sich wie ein Messwert, war aber die
      // Untergrenze.
      const summe = (s ? s.value : 0) + ersteBoxWert;
      // Ohne Live-Wert ist die Summe eine Untergrenze und wird auch so geschrieben -
      // sonst stuende ueber zwei Zeilen "16,95 €" und "mind. 80 €" eine Endsumme,
      // die exakter aussieht als ihre eigenen Posten.
      const summeText = boxwertLive ? eur(summe) : "mind. " + eur(summe);
  
  
      return `
        
        <div class="uebersicht-karte">
          <div class="uebersicht-zeile uebersicht-kopf"><span>Enthalten</span><b>Warenwert</b></div>
          <div class="uebersicht-zeile"><span>${s ? s.name : "—"}</span><b>${eur(s ? s.value : 0)}</b></div>
          <div class="uebersicht-zeile"><span>Erste Trendbox</span><b>${boxwertErsteText}</b></div>
        </div>
        
        <div class="offer-summe">
          <div class="summe-preis">
            <span class="summe-label">DU ZAHLST</span>
            <strong>${eur(D.preis.monat)}</strong>
            <span class="summe-takt">pro Monat</span>
          </div>
          <div class="summe-wert">
            <span class="summe-label">WARENWERT</span>
            <b>${summeText}</b>
          </div>
        </div>
        <div class="lieferlogik">
          <p class="lieferlogik-zeile"><b>Dein erstes Paket</b>${s ? s.name : "Dein Geschenk-Set"} + deine erste Trendbox — zusammen in einer Sendung.</p>
          <p class="lieferlogik-zeile"><b>Danach</b>Ab dem Folgemonat kommt jeden Monat deine Trendbox. Mind. 10 Produkte.</p>
          <p class="lieferlogik-zeile"><b>Kündigung</b>Jederzeit, keine Mindestlaufzeit.</p>
        </div>`;
    }
  
    function schrittInhalt() {
      return SCHRITT_RENDER[wbState.schritt - 1]();
    }
  
    /* Erster Schritt: die beiden Bestandteile als Kacheln, darunter die drei
       Bedingungen. Nutzt bewusst dieselben .karte-Styles wie der Angebots-Block auf
       der Landingpage - wer geklickt hat, soll dasselbe Bild wiedererkennen und
       nicht glauben, er sei woanders gelandet. Reihenfolge wie dort (Geschenk-Set,
       dann Mystery), auch wenn das Vorbild sie im Flow dreht: Wiedererkennung
       schlaegt hier Vorlagentreue. */
    function uebersichtInhalt() {
      const setwertMax = Math.max(...D.sets.map((x) => x.value));
      return `
        <div class="offer-karten">
          <article class="karte karte-gewaehlt">
            <span class="karte-tag">Du wählst</span>
            <h3>Dein Geschenk-Set</h3>
            <p class="karte-meta">Nur Originalgrößen</p>
          </article>
          <span class="plus" aria-hidden="true"></span>
          <article class="karte karte-mystery">
            <span class="karte-tag">Erste Trendbox</span>
            <h3>Deine erste Trendbox</h3>
            <p class="karte-meta">${D.willkommensbox.produkte} Produkte aus Food, Wellness, Beauty &amp; mehr</p>
          </article>
        </div>
        <div class="offer-summe">
          <div class="summe-preis">
            <span class="summe-label">DU ZAHLST</span>
            <strong>${eur(D.preis.monat)}</strong>
            <span class="summe-takt">pro Monat</span>
          </div>
          <div class="summe-wert">
            <span class="summe-label">WARENWERT</span>
            <b>${eurGanz(gesamt)}</b>
          </div>
        </div>
        <ul class="flow-fakten">
          <li>Monatsabo, jederzeit kündbar</li>
          <li>Ab dem 2. Monat: jeden Monat deine Trendbox</li>
          <li>Kostenloser Versand</li>
        </ul>`;
    }
  
    /* Reihenfolge der Schritte an EINER Stelle. Die Funktionen behalten ihre alten
       Namen - sie umzubenennen haette nur Verwechslungsgefahr erzeugt, ohne dass
       sich ihr Inhalt geaendert haette. */
    const SCHRITT_RENDER = [uebersichtInhalt, schritt1Inhalt, schritt4Inhalt];
  
    /* ---------- Kopf / Navigation ---------- */
    /* 19.08. (Lene): "ich sehe erst gefuehlt im allerletzten Schritt, dass ich den
       Preis zahle und den bekomme". Stimmte: der Monatspreis stand nur auf der
       Uebersicht (Schritt 1, klein in der Haken-Zeile) und dann erst wieder in der
       Zusammenfassung (Schritt 5). Dazwischen - Set waehlen, Geschmack, Hauttyp -
       konnte man drei Schritte lang klicken, ohne zu wissen, worauf man zusteuert.
       Der Streifen haengt jetzt am Fortschrittsbalken, also am Rahmen und nicht am
       Inhalt: er beantwortet keine Frage des Schritts, er ist die Konstante.
       Nicht auf Schritt 1 und nicht auf dem letzten - beide tragen den Preis
       bereits gross im eigenen Block, dort waere der Streifen die dritte Nennung
       derselben Zahl auf einem Bildschirm. */
    function preisStrip() {
      if (wbState.schritt === 1 || wbState.schritt === SCHRITTE) return "";
      return `<p class="wizard-preis">Du zahlst <b>${eur(D.preis.monat)}/Monat</b> · jederzeit kündbar · ab dem 2. Monat deine Trendbox</p>`;
    }
  
    function schrittHeader() {
      const inh = SCHRITT_INHALTE[wbState.schritt];
      return `
        <div class="wizard-progress">
          <span class="wizard-progress-label">Schritt ${wbState.schritt} von ${SCHRITTE}</span>
          <div class="wizard-progress-track"><div class="wizard-progress-fill" style="width:${(wbState.schritt / SCHRITTE) * 100}%"></div></div>
          ${preisStrip()}
        </div>
        <div class="wizard-head">
          <h2>${inh.ueberschrift}</h2>
          <p class="sub">${inh.unterzeile}</p>
        </div>`;
    }
  
    function wizardNav() {
      /* Letzter Schritt: in die klebende Leiste gehoert der KAUF, nicht der Rueckweg.
         Vorher stand hier nur "Zurueck" - mit der klebenden Leiste (17.08.) waere
         ausgerechnet der Ausstieg dauerhaft sichtbar gewesen, waehrend der Kaufknopf
         im Fluss nach oben wegscrollt.
         "Zurueck" bleibt trotzdem, aber als leiser Textlink: wer seine Wahl nicht mehr
         korrigieren kann, bricht eher ab als dass er blind kauft - ein gleichrangiger
         Knopf neben dem Kauf-CTA holt sich dafuer aber zu viel Aufmerksamkeit.
         10.09.2026 (Alex): Knopf hiess "Fuer 33,95 EUR/Monat starten". Der Preis steht
         zwei Zentimeter darueber schon zweimal (Zahl-Kachel "DU ZAHLST" und der
         Warenwert daneben) - eine dritte Nennung genau auf dem Klick ist reine
         Preis-Betonung im Moment der Entscheidung. Jetzt "Jetzt starten".
         Rechtlich haengt daran nichts: die Button-Loesung (Paragraph 312j BGB) greift
         am zahlungspflichtigen Bestellknopf im Shopify-Checkout, nicht hier. */
      if (wbState.schritt === SCHRITTE) {
        return `
          <div class="wizard-nav wizard-nav--abschluss">
            <button type="button" class="cta" data-cta-abschluss>Jetzt starten</button>
            <p class="wizard-cta-hinweis" id="wizard-cta-hinweis" hidden>Prototyp — hier ginge es zur Kasse.</p>
            <button type="button" class="btn-zurueck btn-zurueck--leise" data-zurueck>Zurück</button>
          </div>`;
      }
      /* 15.09.2026 (Robin: "bei jedem Schritt ist die Anordnung der Zurueck-Buttons
         anders, beim ersten ist er nicht vorhanden"; Michelle: "einheitlich mit dem
         letzten Screenshot"). Alle Schritte jetzt wie der Abschluss: Knopf breit oben,
         "Zurueck" als leiser Link darunter. Vorher stand in Schritt 2 ein
         gleichrangiger Kasten links neben "Weiter" und in Schritt 1 gar nichts.
         Schritt 1 fuehrt zurueck zur Landingpage - derselbe Weg wie
         "Zurueck zur Uebersicht" oben (data-flow-zurueck, im Theme ein echter
         Seitenwechsel), nicht ins Leere. */
      const erlaubt = weiterErlaubt();
      return `
        <div class="wizard-nav wizard-nav--abschluss">
          <button type="button" class="cta" data-weiter${erlaubt ? "" : " disabled"}>Weiter</button>
          ${wbState.schritt > 1
            ? '<button type="button" class="btn-zurueck btn-zurueck--leise" data-zurueck>Zurück</button>'
            : '<button type="button" class="btn-zurueck btn-zurueck--leise" data-flow-zurueck>Zurück</button>'}
        </div>`;
    }
  
    /* ---------- Render ---------- */
    let letzterSchrittGezeigt = null;
  
    function render() {
      const wizard = document.querySelector("#wizard");
      wizard.innerHTML = `<div class="wizard-inner">${schrittHeader()}<div class="wizard-body">${schrittInhalt()}</div>${wizardNav()}</div>`;
  
      if (wbState.schritt !== letzterSchrittGezeigt) {
        letzterSchrittGezeigt = wbState.schritt;
        wbEvent("wizard_step_view");
      }
    }
  
    /* ---------- Aktionen ---------- */
    function geheWeiter() {
      if (!weiterErlaubt()) return;
      wbEvent("wizard_step_complete");
      geheZu(wbState.schritt + 1);
    }
  
    function geheZurueck() {
      geheZu(wbState.schritt - 1);
    }
  
    function waehleSet(key) {
      const s = findSet(key);
      if (!s || !s.verfuegbar) return;
      wbState.set = key;
      wbEvent("wizard_set_selected", { wizard_set_wert: s.value });
      render();
    }
  
  
  
    /* ---------- Kasse ----------
       Eigener, template-gescopter Weg in den Warenkorb. Bewusst NICHT das
       shopeigene assets/tb-component-subscription-select.js: dessen addToCart()
       haengt eine zweite Produkt-ID bedingungslos an, ohne data-payment-type zu
       pruefen, und die Datei laeuft auf ALLEN Abo-Landingpages. Ein eigener Pfad
       erbt den Fehler nicht und kann die anderen Seiten nicht mitreissen.
  
       Die Varianten-IDs stehen NICHT hier, sondern im Theme-Editor an der Section
       und kommen als window.WB_CART herein. Zwei Gruende: sie sind Shop-Daten und
       kein Seiten-Inhalt, und wer sie tauscht (neues Set, neuer Tarif) soll dafuer
       keine JS-Datei anfassen muessen.
       Im Prototyp gibt es das Objekt nicht - dann bleibt es beim Hinweis. */
    function ctaHinweis(text, istFehler) {
      const el = document.querySelector("#wizard-cta-hinweis");
      if (!el) return;
      if (text) el.textContent = text;
      el.classList.toggle("ist-fehler", !!istFehler);
      el.hidden = false;
    }
  
    function cartPost(pfad, daten) {
      return fetch(pfad, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify(daten),
      }).then((r) =>
        r.json().catch(() => ({})).then((j) => {
          // Shopify antwortet bei "ausverkauft" mit 422 und einer deutschen
          // description - die ist fuer die Kundin brauchbar, also durchreichen.
          if (!r.ok) throw new Error((j && (j.description || j.message)) || ("HTTP " + r.status));
          return j;
        })
      );
    }
  
    function starteCheckout(knopf) {
      wbEvent("wizard_abschluss");
      const cfg = window.WB_CART;
      if (!cfg) {
        ctaHinweis(null, false); // Prototyp: der Hinweis steht schon im Markup
        return;
      }
      const setVariante = cfg.sets ? cfg.sets[wbState.set] : null;
      if (!cfg.flex || !cfg.plan || !setVariante) {
        // Im Theme-Editor fehlt eine ID. Ehrlich benennen, welche - sonst sucht
        // man an der falschen Stelle.
        const fehlt = !cfg.flex ? "die Varianten-ID des Flex-Abos"
          : !cfg.plan ? "die ID des Zahlungsplans"
          : "die Varianten-ID fuer dieses Geschenk-Set";
        ctaHinweis("Hier fehlt noch " + fehlt + " in den Section-Einstellungen.", true);
        wbEvent("wizard_checkout_fehler", { wizard_fehler: "id_fehlt" });
        return;
      }
  
      // Herkunft mitgeben: unterstrichene Eigenschaften sind im Warenkorb und im
      // Beleg unsichtbar, stehen aber an der Bestellung - sonst ist spaeter nicht
      // zu trennen, welche Landingpage den Kauf gebracht hat.
      const eigenschaften = { _lp: "lp-willkommensbox", _set: wbState.set };
      const zeilen = [
        { id: Number(cfg.flex), quantity: 1, selling_plan: Number(cfg.plan), properties: eigenschaften },
        { id: Number(setVariante), quantity: 1, properties: eigenschaften },
      ];
      if (cfg.extra) zeilen.push({ id: Number(cfg.extra), quantity: 1, properties: eigenschaften });
  
      if (knopf) {
        knopf.disabled = true;
        knopf.dataset.beschriftung = knopf.textContent;
        knopf.textContent = "Einen Moment …";
      }
      function wiederFrei() {
        if (!knopf) return;
        knopf.disabled = false;
        knopf.textContent = knopf.dataset.beschriftung || "Jetzt starten";
      }
  
      // Warenkorb vorher leeren: dieser Weg verkauft genau ein Paket. Haengt noch
      // ein anderes Abo drin, entsteht ein Mischwarenkorb, den der Checkout nicht
      // sauber aufloest. Schalter in den Section-Einstellungen.
      const vorlauf = cfg.leeren ? cartPost("/cart/clear.js", {}) : Promise.resolve();
      vorlauf
        .then(() => cartPost("/cart/add.js", { items: zeilen }))
        .then(() => {
          window.location.href = cfg.ziel === "warenkorb" ? "/cart" : "/checkout";
        })
        .catch((f) => {
          const grund = (f && f.message) ? f.message : "unbekannter Fehler";
          wbEvent("wizard_checkout_fehler", { wizard_fehler: grund });
          ctaHinweis("Das hat gerade nicht geklappt: " + grund + " — bitte noch einmal versuchen.", true);
          wiederFrei();
        });
    }
  
    /* ---------- Event-Delegation (Wizard-Container bleibt stabil, nur sein innerHTML wechselt) ---------- */
    const wizardEl = document.querySelector("#wizard");
  
    wizardEl.addEventListener("click", (e) => {
      // ZUERST der Inhalt-Schalter: er liegt IN der Karte, ohne diese Abfrage vorher
      // wuerde der Klick als Set-Auswahl durchgehen (siehe setKarte).
      const inhaltEl = e.target.closest("[data-set-inhalt]");
      if (inhaltEl) {
        e.stopPropagation();
        const k = inhaltEl.dataset.setInhalt;
        wbState.setOffen = wbState.setOffen === k ? null : k;
        render();
        return;
      }
      const setKarteEl = e.target.closest(".set-karte");
      if (setKarteEl && !setKarteEl.classList.contains("ist-weg")) {
        waehleSet(setKarteEl.dataset.set);
        return;
      }
      const weiterEl = e.target.closest("[data-weiter]");
      if (weiterEl && !weiterEl.disabled) {
        geheWeiter();
        return;
      }
      const zurueckEl = e.target.closest("[data-zurueck]");
      if (zurueckEl) {
        geheZurueck();
        return;
      }
      const ctaEl = e.target.closest("[data-cta-abschluss]");
      if (ctaEl) {
        starteCheckout(ctaEl);
        return;
      }
    });
  
    wizardEl.addEventListener("keydown", (e) => {
      if (e.key !== "Enter" && e.key !== " ") return;
      const setKarteEl = e.target.closest(".set-karte");
      if (setKarteEl && !setKarteEl.classList.contains("ist-weg")) {
        e.preventDefault();
        waehleSet(setKarteEl.dataset.set);
      }
    });
  
    wizardEl.addEventListener("change", (e) => {
    });
  
    render();
  }

})();
